exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scroll_div[data-v-774ba0e6] {\n  margin-top: 0.3rem;\n}\n", ""]);

// exports
